import i18n from '@/i18n'

export default [
  {
    path: '/configurations',
    component: () => import(/* webpackChunkName: "configuration" */ '@/views/Configurations.vue'),
    children: [
      {
        path: '',
        name: 'configurationsOverview',
        component: () => import(/* webpackChunkName: "configuration" */ '@/components/Configurations/Overview/ConfigurationsOverview.vue'),
        meta: {
          permissions: ['Portal.Terminals.Read'],
          menu: {
            index: 50,
            routeName: 'configurationsOverview',
            activeWhen: ['configurationsOverview', 'configurationDetail'],
            title: i18n.t('label.configuration'),
            icon: ['fal', 'cogs'],
            canShow: ({ context }) => !context.isSelected('configuration'),
            hasSelectedContext: ['business', 'merchant']
          }
        }
      },
      {
        path: ':configurationId',
        name: 'configurationDetail',
        component: () => import(/* webpackChunkName: "configuration" */ '@/components/Configurations/Detail/ConfigurationDetail.vue'),
        meta: {
          permissions: ['Portal.Terminals.Read'],
          menu: {
            index: 51,
            routeName: 'configurationDetail',
            routeParams: context => context.isSelected('configuration') ? ({ 'configurationId': context.configuration.id }) : {},
            activeWhen: ['configurationsOverview', 'configurationDetail'],
            title: i18n.t('label.configuration'),
            icon: ['fal', 'cogs'],
            canShow: ({ context }) => context.isSelected('configuration'),
            hasSelectedContext: ['business', 'merchant']
          }
        },
        props: true
      },
      {
        path: ':configurationId/hosted-payment-page/:hostedPaymentPageReference',
        name: 'hostedPaymentPageDetail',
        component: () => import(/* webpackChunkName: "configuration" */ '@/components/Configurations/Detail/Tabs/HostedPaymentPagesConfiguration/Detail/HostedPaymentPagesDetail.vue'),
        meta: {
          layout: 'editor',
          permissions: ['Portal.Terminals.Read']
        },
        props: true
      }
    ]
  }
]
